export default __webpack_public_path__ + "static/media/@flaamorais.f3f7ff9b.jpg";